import React from 'react';

const AgeMenu=() => {
    return (
        <div>
            <h1>
                Age:
            </h1>
            <input id = "age" placeholder='Any'>
            </input>
        </div>

    )
}

export default AgeMenu